import { UF } from '@usucampeao/interfaces';
import { IsEnum, IsIn, IsNotEmpty, IsOptional, IsString, ValidateIf } from 'class-validator';
import { GatewayPagamento } from '../pagamento';
import { ProjetoEditarFormDataConstructorProps, ProjetoEditarFormDataDto } from './projeto-editar-form-data.dto';
import { ProjetoCategoria, ProjetoTipo } from './projeto-tipo.enum';

type ProjetoCriarFormDataConstructorProps = ProjetoEditarFormDataConstructorProps & {
  tipo: ProjetoTipo;
  categoria: ProjetoCategoria;
  nucleoId: string;
  semPagamento: boolean;
  reurbGratuito: boolean;
  cidade: string;
  estado: UF;
  importarQuadras?: boolean;
}

export class ProjetoCriarFormDataDto extends ProjetoEditarFormDataDto {
  @IsString()
  @IsNotEmpty()
  tipo: ProjetoTipo

  @IsEnum(ProjetoCategoria)
  @IsNotEmpty()
  categoria: ProjetoCategoria;

  @IsString()
  @IsNotEmpty()
  nucleoId: string;

  @IsIn(['true', 'false'])
  @IsString()
  @IsOptional()
  semPagamento: string;

  @IsIn(['true', 'false'])
  @IsString()
  @IsOptional()
  reurbGratuito: string;

  @IsString()
  @IsNotEmpty()
  cidade: string;

  @IsString()
  @IsNotEmpty()
  estado: UF;

  @IsIn(['true', 'false'])
  @IsString()
  @IsOptional()
  importarQuadras: string;

  @IsEnum(GatewayPagamento)
  @IsNotEmpty()
  @ValidateIf((object) => object.semPagamento === 'false')
  gatewayPagamento: GatewayPagamento;

  static create(props: ProjetoCriarFormDataConstructorProps): ProjetoCriarFormDataDto {
    const projetoCriarFormDataDto: ProjetoCriarFormDataDto = ProjetoEditarFormDataDto.create(props) as ProjetoCriarFormDataDto;
    projetoCriarFormDataDto.tipo = props.tipo;
    projetoCriarFormDataDto.categoria = props.categoria;
    projetoCriarFormDataDto.nucleoId = props.nucleoId;
    projetoCriarFormDataDto.semPagamento = props.semPagamento.toString();
    projetoCriarFormDataDto.reurbGratuito = props.reurbGratuito.toString();
    projetoCriarFormDataDto.cidade = props.cidade;
    projetoCriarFormDataDto.estado = props.estado;
    projetoCriarFormDataDto.importarQuadras = props.importarQuadras ? 'true' : 'false';
    projetoCriarFormDataDto.gatewayPagamento = props.gatewayPagamento;
    return projetoCriarFormDataDto;
  }
}
